module.exports = __webpack_public_path__ + "img/3.86c4fe58.jpg";